<template>
    <div class="neirong">
        <a-row style="height:100%">
            <a-col :span="4" style="height:100%">
                <DetailLeft :jzxq="jzxq" :chatdata="chatdata" />
            </a-col>
            <a-col :span="16" style="padding:0 50px">
                <DetailCenter :jzxq="jzxq" :chatdatacf="chatdatacf" />
            </a-col>
            <a-col :span="4">
                <DetailRight :jzxq="jzxq" />
            </a-col>
        </a-row>
    </div>
</template>

<script>

import http from "@/api/http";
import DetailLeft from "./xiangqing/DetailLeft.vue";
import DetailRight from "./xiangqing/DetailRight.vue";
import DetailCenter from "./xiangqing/DetailCenter.vue";
import { onMounted, defineComponent, ref } from "vue";
import { useStore } from "vuex";
export default defineComponent({
    name: 'JiZhan',
    components: {
        DetailLeft,
        DetailRight,
        DetailCenter
    },

    setup() {
        const store = useStore()
        let stationid = store.getters['User/stationid']

        let jzxq = ref({})

        let chatdata = ref([])
        let chatdatacf = ref([])

        let gaojing = ref([])

        const getData = () => {

            http.get("/base_station/" + stationid).then((res) => {

                jzxq.value = res.data.base_info
                let today_peak_shaving_total = res.data.today_peak_shaving_total
                let month_peak_shaving_total = res.data.month_peak_shaving_total
                let today_power_rate_save = res.data.today_power_rate_save
                let month_power_rate_save = res.data.month_power_rate_save
                let battery_config = res.data.battery_config
                let allow_charge_total = res.data.allow_charge_total
                let allow_discharge_total = res.data.allow_discharge_total

                let charge_discharge_total = res.data.charge_discharge_total
                let battery_temp = res.data.battery_temp
                let power_reservation = res.data.power_reservation
                let battery_status = res.data.battery_status


                jzxq.value = Object.assign({}, jzxq.value, { battery_status, power_reservation, battery_temp, charge_discharge_total, allow_discharge_total, allow_charge_total, battery_config, today_peak_shaving_total, month_peak_shaving_total, today_power_rate_save, month_power_rate_save })
                chatdata.value = res.data.recently6
                chatdatacf.value = res.data.recently12
            });

        };
        onMounted(() => {
            //组件挂载时的生命周期执行的方法


            getData();
        });
        return {
            getData, jzxq, gaojing, chatdata, chatdatacf
        }
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.neirong {
    padding-top: 20px;
    height: 100%;
    background: url(" @/assets/bg3.png");
    background-size: 100% 100%;

}
</style>
